import { isSSR } from "../../lib/isSSR/index.js";

/**
 * Invia un messaggio di contatto tramite l'API del server
 * @param {Object} data Dati del modulo di contatto
 * @returns {Promise<Object>} Promise con il risultato dell'operazione
 */
export async function submitContactForm(data) {
  console.log('=== INIZIO PROCESSO DI INVIO MESSAGGIO DI CONTATTO ===');
  console.log('Dati ricevuti:', {
    name: data.name,
    email: data.email,
    subject: data.subject || '(non specificato)',
    messageLength: data.message ? data.message.length : 0,
    hasRecaptchaToken: !!data.recaptchaToken,
    recaptchaTokenLength: data.recaptchaToken ? data.recaptchaToken.length : 0
  });
  
  try {
    // Validazione base
    console.log('Esecuzione validazione dati...');
    
    if (!data.name || data.name.trim() === '') {
      console.error('Validazione fallita: nome mancante');
      return { success: false, message: 'Il nome è obbligatorio' };
    }
    
    if (!data.email || !/^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+[.][A-Za-z]+$/.test(data.email)) {
      console.error('Validazione fallita: email non valida', data.email);
      return { success: false, message: 'Email non valida' };
    }
    
    if (!data.message || data.message.length < 10) {
      console.error('Validazione fallita: messaggio troppo corto', data.message ? data.message.length : 0);
      return { success: false, message: 'Il messaggio deve contenere almeno 10 caratteri' };
    }
    
    if (!data.recaptchaToken) {
      console.error('Validazione fallita: token reCAPTCHA mancante');
      return { success: false, message: 'Verifica reCAPTCHA fallita' };
    }
    
    console.log('Validazione dati completata con successo');
    
    // Se siamo in modalità SSR, non possiamo fare richieste fetch
    if (isSSR()) {
      console.warn('Tentativo di inviare un messaggio di contatto in modalità SSR');
      return { 
        success: false, 
        message: 'Non è possibile inviare messaggi durante il rendering lato server' 
      };
    }
    
    // Determina l'URL dell'API in base all'ambiente
    const apiUrl = '/api/contact';
    console.log(`Invio richiesta all'endpoint: ${apiUrl}`);
    
    // Invia i dati all'API
    console.log('Invio dati al server...');
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    console.log(`Risposta ricevuta dal server. Status: ${response.status} ${response.statusText}`);
    
    // Analizza la risposta
    const result = await response.json();
    console.log('Risposta JSON dal server:', result);
    
    if (!response.ok) {
      console.error('Errore durante l\'invio del messaggio di contatto:', result);
      console.error('Dettagli errore:', {
        status: response.status,
        statusText: response.statusText,
        errorMessage: result.message,
        errorDetails: result.error
      });
      
      return { 
        success: false, 
        message: result.message || 'Si è verificato un errore durante l\'invio del messaggio',
        error: result.error,
        status: response.status
      };
    }
    
    console.log('Messaggio inviato con successo!', result);
    return {
      success: true,
      message: result.message || 'Messaggio inviato con successo! Ti contatteremo presto.',
      messageId: result.messageId
    };
  } catch (error) {
    console.error('Errore durante l\'invio del messaggio di contatto:', error);
    console.error('Stack trace:', error.stack);
    return {
      success: false,
      message: 'Si è verificato un errore durante l\'elaborazione del messaggio',
      errorDetails: error.message,
      errorType: error.name
    };
  } finally {
    console.log('=== FINE PROCESSO DI INVIO MESSAGGIO DI CONTATTO ===');
  }
}
